import { useEffect, useState } from 'react';
import CalendarBase from './Base';


function CalendarDay({ changeCb = () => { }, closeCb = () => { }, date = undefined, disabled = false, ...props }) {
  const [day, setDay] = useState(undefined);

  const handleDayClick = new_day => {
    setDay(new_day);
  };

  const handleClose = () => {
    changeCb(day);
    closeCb();
  };

  useEffect(() => {
    setDay(date ? new Date(date) : undefined);
  }, [date]);

  return (
    <CalendarBase
      closeCb={closeCb}
      className={props.className}
      handleClose={handleClose}
      selected={day}
      disabled={disabled}
      onDayClick={handleDayClick}
    />
  );
}

export default CalendarDay;
